export default __webpack_public_path__ + "static/media/cp_geo_at.014b94b1.svg";